import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=1ba90b36&scoped=true"
import script from "./Testimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonials.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=1ba90b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba90b36",
  null
  
)

export default component.exports